module.exports = __webpack_public_path__ + "img/gray-invoice.5802659f.svg";